/* RESPONSIBLE TEAM: team-ml */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { ReactRoute } from 'embercom/lib/react-route';

class PersonalisationStandaloneRoute extends Route {
  @service declare intl: IntlService;

  reactEnabled() {
    return true;
  }

  get titleToken() {
    return this.intl.t('standalone.navbar.personalisation');
  }
}

export default ReactRoute(PersonalisationStandaloneRoute);
